/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SettlementDetailAgreementDecisionModel} from '../../services/settlement-detail-configuration/models/settlement-detail-agreement-decision.model';


@Component({
    selector: 'app-settlement-reject-motivation',
    templateUrl: './settlement-reject-motivation.component.html',
    styleUrls: ['./settlement-reject-motivation.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementRejectMotivationComponent {
    @Input() agreementDecision?: SettlementDetailAgreementDecisionModel;

    readonly LABEL_REASON = 'Reason for rejection';
    readonly LABEL_REJECTED = 'Rejected by';
}
